// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import { css } from 'load-js-css';

import ColumnGrid, {Column} from '@phg/stilo-toolbox/components/ColumnGrid';
import { makeTheme, withStyles, withTheme } from '@phg/stilo-toolbox/components/ThemeProvider';
import Panel from '@phg/stilo-toolbox/components/Panel';

import LanguageSelector from 'app/components/LanguageSelector';
import Error from 'app/components/errorComponent';
import Login from 'app/components/loginComponent';
import Stepper from 'app/components/Stepper';
import {l} from 'app/Translate';

import TopBar from 'app/default/components/topbar';
import BottomBar from 'app/default/components/bottombar';

import UserComponent from 'app/default/steps/UserComponent';
import AddressComponent from 'app/default/steps/AddressComponent';
import CompanyComponent from 'app/default/steps/CompanyComponent';
import makeStyle from './style';
import networkStyleMap from './styleMap';
import networkStyleMapOverwrite from './styleMapOverwrite';

css({ href: '//fonts.googleapis.com/css?family=Lato:400,700' });
css({ href: '//fonts.googleapis.com/css?family=Montserrat:800,800i' });

const Customisation = ({ classes, fatalErrorOccurred, networkId, isAvailable, captchaProvider }) => {
    if (!isAvailable) {
        return (
            <div className={classes.BigError}>
                <Error error={l('URL is now invalid')} />
            </div>
        );
    }

    const contents = fatalErrorOccurred ? <Error /> : (
        <Panel
            id='onboarding-panel' header={l('Sign up to the :name network', { name: 'Partnerize' })}
            className={classes.Onboarding}
        >
            <ColumnGrid>
                <Stepper container={Column}>
                    <UserComponent />
                    <AddressComponent />
                    <CompanyComponent networkId={networkId} captchaProvider={captchaProvider} />
                </Stepper>
            </ColumnGrid>
            <Login/>
        </Panel>
    );

    return (
        <div className={classes.SignupForm}>
            <TopBar className={classes.Topbar}><LanguageSelector/></TopBar>
            <div className="content-wrapper">
                <div className="intro-panel">
                    <div className="inner">
                        <h2>{l('Join the Partnerize Partner Community')}</h2>
                        <p>
                            {l('Many of the world\'s largest partnership programs are managed through our SaaS partner management platform. '
                            + 'We work with 300,000+ partners and 300+ leading global brands, driving '
                            + '$6B in sales and $500M in partner payments every year.'
                            + ' Get your share. Come grow with us by signing up today!')}
                        </p>
                    </div>
                </div>
                <div className="content-panel">
                    {contents}
                </div>
            </div>
            <BottomBar className={classes.Bottombar}/>
        </div>
    );
};

Customisation.propTypes = {
    networkId: PropTypes.string.isRequired,
    networkName: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    fatalErrorOccurred: PropTypes.bool.isRequired,
    isAvailable: PropTypes.bool,
    captchaProvider: PropTypes.string
};

const OnboardingApp = withStyles(makeStyle)(Customisation);

OnboardingApp.PageTitle = l(':network Signup Page', { network: 'Partnerize' });

const theme = makeTheme({globalVariables: networkStyleMap}, {globalVariables: networkStyleMapOverwrite});
export default withTheme(theme)(OnboardingApp);

